import { FC } from "react"
import { Stack, Typography } from "@mui/material"
import { Userbot } from "../../interfaces"

const permission = (value: boolean | undefined) =>
  value === true ? "да" : value === false ? "нет" : "неизвестно"

/** Only named policy fields are displayed; partial persisted rows may contain secrets. */
export const ClientPolicy: FC<{
  client: Userbot.ClientPolicy & { accountId?: string | null }
  showScope?: boolean
  showHelp?: boolean
}> = ({ client, showScope = true, showHelp = true }) => (
  <Stack
    spacing={0.5}
    sx={{ py: 0.5, whiteSpace: "normal", overflowWrap: "anywhere" }}
  >
    {showScope && (
      <Typography variant="caption">
        Account scope: {client.accountId ?? "не привязан / неизвестно"}
      </Typography>
    )}
    <Typography variant="caption">
      policyVersion:{" "}
      {typeof client.policyVersion === "string"
        ? client.policyVersion
        : "неизвестно"}
    </Typography>
    {client.roles?.length ? (
      client.roles.map((role, index) => (
        <Typography variant="caption" key={index}>
          Сохранено ({role.name ?? "роль"}): активна:{" "}
          {permission(role.isActive)}; обновления:{" "}
          {permission(role.updatesEnabled)}; catch-up:{" "}
          {permission(role.catchUpEnabled)}
        </Typography>
      ))
    ) : (
      <Typography variant="caption">Сохранено (роли): неизвестно</Typography>
    )}
    <Typography variant="caption">
      {client.effectivePolicy
        ? `Эффективно: обновления: ${permission(client.effectivePolicy.updates)}; catch-up: ${permission(client.effectivePolicy.catchUp)}`
        : "Эффективно: неизвестно"}
    </Typography>
    {showHelp && (
      <Typography variant="caption" color="text.secondary">
        Catch-up требует обоих разрешений на одной и той же активной роли.
        Активность клиента, авторизация и привязка аккаунта проверяются
        отдельно.
      </Typography>
    )}
  </Stack>
)
